import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatDataBeforeView } from '../../../helpers/GeneralHelper';

export const UserView = ({module, showModal, setShowModal, data}) => {

  const inputFields = {
    user_name: 'Name',
    user_dob: 'Date of Birth',
    user_gender: 'Gender',
    designation_name: 'Designation',
    manager_name: 'Manager',
    urole_title: 'User Role',
    user_mobile: 'Mobile',
    user_email: 'Email',
    user_start_date: 'Start Date',
    user_address: 'Address',
    user_update_time: 'Updated At',
    user_create_time: 'Created At',
  }
  const formatOptions = [
    {
      'type': 'date',
      'column': 'user_dob',
    },
    {
      'type': 'date',
      'column': 'user_start_date',
    },
    {
      'type': 'datetime',
      'column': 'user_update_time',
    },
    {
      'type': 'datetime',
      'column': 'user_create_time',
    },
    {
      'type': 'capitalize',
      'column': 'user_gender',
    },
  ];

  const [fields, setFields] = useState(inputFields);
  useEffect(() => {
    if (data) {
      setFields(formatDataBeforeView(data, formatOptions));
    }
  }, [data]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
      <Modal.Header closeButton>
          <Modal.Title>View {module.singularTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-bordered table-hover table-sm">
          <tbody>
            {Object.keys(inputFields).map((item) => 
              <tr key={item}>
                <td>{inputFields[item]}</td>
                <th>{fields[item]}</th>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
